<template>
    <div>
      <nx-form-text :label="$t('message.form.fields.title')"
                    name="title"
                    :value="draft.title"
                    validation="required"/>
      <nx-form-text :label="$t('message.form.fields.signatureAuthorName')"
                    name="signatureAuthorName"
                    :value="draft.signatureAuthorName" />
    </div>
</template>

<script>
import NxForm from '@/modules/form/Form';
import NxFormText from '@/modules/form/components/FormText';

export default {
  name: 'nx-wizard-multiple-images-form',
  extends: NxForm,
  components: {
    NxFormText,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    validationMode: {
      type: String,
      default: 'eager',
    },
  },
  methods: {
    updateField(field, value) {
      console.log('%c[Form] updateField', 'color:darkorange', field, value);
      this.$emit('input', {
        ...this.value,
        [field]: value,
      });
    },
  },
  watch: {
    form: {
      handler(value) {
        this.$emit('valid', value.valid);
      },
      immediate: true,
    },
  },
};
</script>
